import React, { useEffect, useMemo } from "react";

import { useTranslation } from "react-i18next";

import { getPaths } from "core/getPaths";
import { useLeague } from "shared/hooks";
import { EntitySoccerLeagueRoles } from "shared/types";
import { Button } from "shared/uikit";

import { isRoleAvailable } from "utils/isRoleAvailable";

import PaymentRequestsTable from "../../Components/PaymentRequestsTable";

const { league: leagueRoutes } = getPaths();

interface PaymentsAllPendingPaymentsProps {
	id: string;
}

const PaymentsAllPaymentRequests: React.FC<PaymentsAllPendingPaymentsProps> = ({ id }) => {
	const { t } = useTranslation();

	const { checkPaymentAccount, getData: getLeagueData } = useLeague();
	const { paymentAccount, userLeagueRoles } = getLeagueData();

	const isOwner = useMemo(() => isRoleAvailable(userLeagueRoles, [EntitySoccerLeagueRoles.OWNER]), [userLeagueRoles]);

	useEffect(() => {
		isOwner && checkPaymentAccount(id);
	}, [checkPaymentAccount, isOwner, id]);

	return (
		<>
			<Button link={`${leagueRoutes.getPath()}/${id}/payments`} className="mb-4">
				{t("back")}
			</Button>
			<PaymentRequestsTable leagueId={id} allowCreatePayments={isOwner && !!paymentAccount?.detailsSubmitted} asPage />
		</>
	);
};

export default PaymentsAllPaymentRequests;
